/* eslint-disable react/prop-types */
import React from 'react';
import { Paper } from 'components';
import { Box, CircularProgress, Skeleton, Typography } from '@mui/material';
import theme from 'theme';

export default function Card(props) {
  const { bgColor, clicked, action, link, data, title, footer, icon } = props;

  // Función para manejar el click
  const handleClick = () => {
    if (clicked && action) {
      // Si se pasó una acción, se ejecuta
      action();
    } else if (clicked && link) {
      // Si hay una liga, redirige
      window.location.href = link;
    }
  };

  return data ? (
    <Paper
      style={{
        padding: theme.spacing(3),
        backgroundColor: bgColor,
        cursor: clicked ? 'pointer' : '',
        height: '100%',
      }}
      onClick={handleClick} // Se ejecuta solo si clicked es true
    >
      <Box sx={{ alignItems: 'center', display: 'flex' }}>
        <Box>
          <Typography
            variant="h5"
            color="white"
            component="p"
            sx={{ fontWeight: 700, fontSize: '1em' }}
          >
            {title}
          </Typography>
          <Typography variant="h3" sx={{ mt: 1 }} color="white">
            {data ? data : <CircularProgress />}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            borderRadius: '50%',
            height: '4rem',
            ml: 'auto',
            width: '4rem',
            justifyContent: 'center',
            background: 'white',
          }}
        >
          {icon}
        </Box>
      </Box>
      {footer && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="caption"
            color="white"
            sx={{ mt: 2 }}
            component="p"
          >
            {footer}
          </Typography>
        </Box>
      )}
    </Paper>
  ) : (
    <Skeleton width="100%" height={150} variant="rectangular" />
  );
}
